import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from "react";
import { getFormBySlug, updateForm } from "../../apis/forms";
import { RENDER_FORMS_URL_PREFIX } from "../../constants/forms.constants";
import { createFormsSurveyCreator } from "../../utils/forms.functions";
import EditorLayout from "../shared/EditorLayout";
var FormsEditor = function () {
    var config = useMemo(function () { return ({
        listPath: "/forms/list",
        urlPrefix: RENDER_FORMS_URL_PREFIX,
        fetchApi: getFormBySlug,
        updateApi: updateForm,
        createCreator: createFormsSurveyCreator,
        defaultAuthRequired: true,
    }); }, []);
    return _jsx(EditorLayout, { config: config });
};
export default FormsEditor;
